import { Platform } from '@cart-services/hooks/fp-b2b/store-map'
import { useFpB2bButlerService } from '@cart-services/hooks/fp-b2b/use-fp-b2b-butler-service'
import { type CountryCode, type ProjectCode } from '@constants'
import { type PropsWithChildren } from 'react'
import { ButlerProvider } from '../../fp-b2b-shared/ai-purchase-order/components/ButlerProvider/ButlerProvider'
import { RefreshButlerToken } from '../../fp-b2b-shared/ai-purchase-order/components/RefreshButlerToken/RefreshButlerToken'

export interface MerchantButlerProviderProps {
  projectCode: ProjectCode
  countryCode: CountryCode
  campaignId: number
  campaignCode: string
}

/** merchant 的 tab 狀態沿用 per-campaign cart store，這裡把它接成 ButlerProvider 的受控 props */
export const MerchantButlerProvider = (props: PropsWithChildren<MerchantButlerProviderProps>) => {
  const { children, projectCode, countryCode, campaignId, campaignCode } = props
  const { selectedTab, setSelectedTab } = useFpB2bButlerService(campaignId, Platform.MERCHANT)

  return (
    <>
      <RefreshButlerToken projectCode={projectCode} campaignCode={campaignCode} />
      <ButlerProvider
        platform={Platform.MERCHANT}
        projectCode={projectCode}
        countryCode={countryCode}
        campaignId={campaignId}
        campaignCode={campaignCode}
        basePath={`/merchant/${campaignCode}`}
        selectedTab={selectedTab}
        onSelectedTabChange={setSelectedTab}
      >
        {children}
      </ButlerProvider>
    </>
  )
}
